// These are just placeholder functions for React web
const noOp = () => null;

export const clearStorage = noOp;

export const getDomain = () => '';
export const setDomain = (domain: string) => noOp();

export const getCookie = () => '';
export const setCookie = (cookie: string) => noOp();

export const clearNativeCookies = async () => {
  return Promise.resolve(null);
};
